import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';

@Component({
  selector: 'app-tour-agencias-confirmadas',
  templateUrl: './tour-agencias-confirmadas.component.html',
  styleUrls: ['./tour-agencias-confirmadas.component.css']
})
export class TourAgenciasConfirmadasComponent implements OnInit, OnDestroy {

  subscription: Subscription;
  subscriptionAg: Subscription;
  subscriptionPas: any;
  idPaquete: Number;
  idAgencia: Number;
  paqueteReservado = [];
  listaReservaciones = [];
  cantidadReservaciones: number;
  idPaquetePasajero: Number;
  filtered: Object[];
  form: FormGroup;
  listaAgencias = [];

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
  ) { }
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      search: [''],     
    });

    this.subscription = this.tourservice.paqueteConfirmado.subscribe(result => {
      this.idPaquete = result;
    });

    this.subscriptionAg = this.tourservice.agenciaConfirmada.subscribe(result => {
      this.idAgencia = result;
    });

    this.subscriptionPas = this.tourservice.paqueteConfirmadoPasajero.subscribe(result => {
      this.idPaquetePasajero = result;
    });

    this.confirmacionesTour();
    this.listaDeAgencias();
  }

  verAgencia(id) {
    //*** stuff
    this.idAgencia = id;
    this.idPaquetePasajero = this.idPaquete;
    this.tourservice.changeAgenciaCnfId(this.idAgencia);
    this.tourservice.changePaqueteIdPasajeroCnf(this.idPaquetePasajero);
    //console.log("la agencia que se toco es:  "+id);
    this.router.navigate(['/admin/tours-agencias-confirmadas-detalle']);
  }

  confirmacionesTour(){  
    this.listaReservaciones = [];
    this.agenciasService.reservacionesTour(this.idPaquete).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.cantidadReservaciones = data.body.length;
          this.listaReservaciones = data.body;
          this.paqueteReservado =  this.listaReservaciones[0].id_paquete;
          //this.filtered = data.body;
        }
        //console.log("cantidad de reservaciones:  " + this.cantidadReservaciones);
        //console.log("el paquete reservado es:  " + this.paqueteReservado);    
        //console.log(this.listaReservaciones);   
      }    
    });    
  }

  listaDeAgencias(){
    this.listaAgencias = [];
    this.agenciasService.agenciasConfPaquete(this.idPaquete).subscribe(data => {
      if(data instanceof HttpResponse){
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.listaAgencias = data.body;
          this.filtered = data.body; console.log(this.filtered );
        }
      }
    })
  }

  onSubmit() { 
    var value = this.f.search.value;
    var recibido = [];
    if(value === ''){
      this.redirectTo(this.router.url); 
    }else {
      var paquete = this.idPaquete.toString(); console.log(paquete + value);
      this.agenciasService.agenciasFiltradas(value, paquete, '2').subscribe(data => {
        if(data instanceof HttpResponse){
          if(data.body !== null && data.body !== undefined && data.body !== ''){
            this.listaAgencias = data.body;
            this.filtered = data.body; console.log(this.filtered );
          }
        }
      });
    }
    this.filtered = recibido
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }  

  get f() { 
    return this.form.controls; 
  }

}
